var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2699 19.9468C24.2434 20.8475 24.2434 22.4238 23.2699 23.3245C22.8206 23.7748 22.2215 24 21.6225 24C20.9485 24 20.3495 23.7748 19.9002 23.3245L12.0374 15.4433L4.09984 23.3245C3.65055 23.7748 3.05148 24 2.45242 24C1.77847 24 1.17941 23.7748 0.730109 23.3245C-0.24337 22.4238 -0.24337 20.8475 0.730109 19.9468L8.59282 11.9906L0.730109 4.10946C-0.24337 3.20876 -0.24337 1.63253 0.730109 0.731822C1.62871 -0.243941 3.20125 -0.243941 4.09984 0.731822L12.0374 8.61298L19.9002 0.731822C20.7988 -0.243941 22.3713 -0.243941 23.2699 0.731822C24.2434 1.63253 24.2434 3.20876 23.2699 4.10946L15.4072 12.0657L23.2699 19.9468Z",
    fill: "#5F6272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.7c1ea4d260417d9221777122f40219c8.svg";
export { ForwardRef as ReactComponent };